import Vue from 'vue'
import App from './App.vue'

import router from '@/router'
import store from '@/store'

import { format, differenceInCalendarDays } from 'date-fns'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import '@/css/tailwind.styl'

const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )


  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    formatDate (date) {
      return format(new Date(date), 'dd.MM.yy')
    },
    dateDistance (date) {
      return differenceInCalendarDays(new Date(date), new Date())
    },
    getFieldByLang (item, field, lang) {
      return item[`${field}_${lang}`]
    },
    ytEmbed (url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      var match = url.match(regExp)

      if (match && match[2].length == 11) {
        return `<iframe width="560" height="315" src="//www.youtube.com/embed/${match[2]}" frameborder="0" allowfullscreen></iframe>`
      } else {
        return 'error'
      }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
